export const integrationsGetTechnologyPartnersData = "/integrations/get_technology_partners_data";
